<!-- Route-transition indicator — visible only for navigations that take a while (e.g. PlanResolver) -->
<sp-nav-progress></sp-nav-progress>

<!-- ── Shell body: optional product rail (home only) + main column ── -->
<div class="shell-body">

<!-- Product switcher rail — only on the homescreen -->
<sp-side-nav *ngIf="isHomePage"></sp-side-nav>

<div class="shell-main">

<!-- ── Global top nav (single bar across all authenticated pages) ── -->
<header class="shell-nav">

  <!-- LEFT: logo on home, breadcrumb on plan pages -->
  <div class="shell-nav__left">

    <!-- Plan pages: back link + name + the plan's platform icon(s) + optional plan-ID badge -->
    <ng-container *ngIf="!isHomePage">
      <a class="shell-nav__back" href="/home" (click)="onBackClick($event)">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10 12L6 8l4-4" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Back to Home
      </a>
      <span class="shell-nav__sep">/</span>
      <span class="shell-nav__plan-title">
        Planning Suite
        <!-- The plan's confirmed platform(s), from the registry; none before one is confirmed -->
        <sp-platform-icon
          *ngFor="let icon of breadcrumb?.platformIcons ?? []"
          class="shell-nav__platform-icon"
          [attr.data-platform]="icon"
          [platform]="icon"
          [size]="18">
        </sp-platform-icon>
      </span>
      <span *ngIf="breadcrumb?.badgeText" class="shell-nav__badge">
        {{ breadcrumb!.badgeText }}
      </span>
    </ng-container>

  </div>

  <!-- RIGHT section: optional CTAs + user menu -->
  <div class="shell-nav__right">

    <!-- CTAs — registered by home component only -->
    <ng-container *ngFor="let action of actions">
      <button
        class="shell-nav__action"
        [class.shell-nav__action--primary]="action.variant === 'primary'"
        [class.shell-nav__action--outline]="action.variant === 'outline'"
        type="button"
        (click)="runAction(action)">
        {{ action.label }}
      </button>
    </ng-container>

    <!-- User menu (always visible) -->
    <sp-user-menu></sp-user-menu>

  </div>
</header>

<!-- ── Page content ── -->
<div class="shell-content">
  <router-outlet></router-outlet>
</div>

</div><!-- /.shell-main -->
</div><!-- /.shell-body -->

<sp-toast></sp-toast>

<!-- App-wide modals, opened from the user menu (mounted once each) -->
<sp-feedback-rating></sp-feedback-rating>
<sp-log-bug-widget></sp-log-bug-widget>
